import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var YardSignOutlineSVG = function YardSignOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M29,6H8V2.93a1,1,0,0,0-2,0V6H2.89a1,1,0,0,0,0,2H6V29.06A1,1,0,0,0,7,30a1,1,0,0,0,1-.93V8h4v2a2,2,0,0,0-2,2v9a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V12a2,2,0,0,0-2-2V8h3a1,1,0,0,0,0-2ZM26,21H12V12H26ZM24,10H14V8H24Z"
  }));
};
YardSignOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(YardSignOutlineSVG);